export const isEnumValue = <TValue extends string>(
  enumObject: Record<string, TValue>,
  value: string,
): value is TValue => (Object.values(enumObject) as string[]).includes(value)

export const parseEnumList = <TValue extends string>(
  enumObject: Record<string, TValue>,
  rawValue: string | null,
): TValue[] | null =>
  rawValue === null
    ? null
    : rawValue.split(',').filter((value): value is TValue => isEnumValue(enumObject, value))

export const parsePositiveInteger = (rawValue: string | null): number | null => {
  const parsedValue = Number(rawValue)
  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : null
}

export const parsePositiveIntegerList = (rawValue: string | null): number[] | null =>
  rawValue === null
    ? null
    : rawValue
        .split(',')
        .map(parsePositiveInteger)
        .filter((parsedValue): parsedValue is number => parsedValue !== null)
